var exports = {
  "pz": "RecentMentionsContent.module__filterButton___OUlpcn",
  "Pt": "RecentMentionsContent.module__filterButtonActive___OUlpcn",
  "XG": "RecentMentionsContent.module__scroller___OUlpcn",
  "bm": "RecentMentionsContent.module__guildGroup___OUlpcn",
  "W1": "RecentMentionsContent.module__messageCard___OUlpcn",
  "v0": "RecentMentionsContent.module__iconMedium___OUlpcn",
};

module.exports = exports;
